import { ListItem, Paper, Typography } from "@mui/material";

export const CustomContentBlock = ({ content }) => {
    return (
        <ListItem sx={{ my: 2 }}>
            <Paper 
                elevation={2} 
                sx={{ 
                    p: 2, 
                    width: '100%',
                    backgroundColor: 'primary.light',
                    color: 'primary.contrastText'
                }}
            >
                <Typography variant="body1">
                    {content}
                </Typography>
            </Paper>
        </ListItem>
    );
}; 